<script setup lang="ts">
import { computed, ref } from 'vue'
import AccountPanelVerificationSteps, { VerificationStep } from '../../AccountPanelVerificationSteps.vue'
import { i18n } from '../../../../localization'
import AccountKycProcessStatusIDNow from './AccountKycProcessStatusIDNow.vue'
import AccountKycProcessStatusSignteq from './AccountKycProcessStatusSignteq.vue'
import { usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'
import { KycProvider } from '../../../../utilities/api'
import Modal from '../../../dialogs/Modal.vue'

const state = usePersonalAccountDataState()

const open = ref(false)

const steps: VerificationStep[] = [
    {
        name: i18n.global.t('verification.complete_data'),
        description: i18n.global.t('verification.complete_data_description'),
        status: computed(() => {
            return state.hasAllRequiredNaturalProfileAttributesForInvestment ? 'complete' : 'current'
        }),
    },
    {
        name: i18n.global.t('verification.kyc_process'),
        description: i18n.global.t('verification.kyc_process_description'),
        component:
            state.naturalProfile.platform_kyc_provider === KycProvider.IDNOW
                ? AccountKycProcessStatusIDNow
                : AccountKycProcessStatusSignteq,
        status: computed(() => {
            if (
                state.naturalProfile.kyc_id ||
                (state.hasAllRequiredNaturalProfileAttributesForInvestment && state.naturalProfile.external_kyc_done)
            ) {
                return 'complete'
                // if (state.naturalProfile.kyc_id) {
                //     return 'complete'
                // } else {
                //     return 'current'
                // }
            } else if (
                state.hasAllRequiredNaturalProfileAttributesForInvestment &&
                !state.naturalProfile.external_kyc_done
            ) {
                return 'current'
            } else {
                return 'upcoming'
            }
        }),
    },
    //removed for secupay
    // {
    //     name: i18n.global.t('verification.wallet_creation'),
    //     description: i18n.global.t('verification.wallet_creation_description'),
    //     status: computed(() => {
    //         if (
    //             state.hasAllRequiredNaturalProfileAttributesForInvestment &&
    //             state.naturalProfile.external_kyc_done &&
    //             !state.naturalProfile.kyc_id
    //         ) {
    //             return 'current'
    //         } else if (state.naturalProfile.kyc_id) {
    //             return 'complete'
    //         } else {
    //             return 'upcoming'
    //         }
    //     }),
    // },
    {
        name: i18n.global.t('verification.verification_successful'),
        description: i18n.global.t('verification.verification_successful_description'),
        status: computed(() => {
            if (state.naturalProfile.kyc_id) {
                return 'complete'
            } else {
                return 'upcoming'
            }
        }),
    },
]
</script>

<template>
    <AccountPanelVerificationSteps :steps="steps" class="mt-4" />
    <div v-if="!state.naturalProfile.kyc_id">
        <div class="mt-6 text-left text-sm text-gray-500">
            {{ i18n.global.t('verification.schedule_kyc_support') }}
        </div>
        <button
            type="button"
            class="items-left justify-left mt-6 inline-flex rounded-md border border-gray-300 bg-white px-5 py-2 text-center text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 disabled:bg-slate-100"
            @click="() => (open = true)">
            <span class="w-full font-bold">{{
                i18n.global.t('verification.schedule_kyc_contact_support_button')
            }}</span>
        </button>

        <Modal v-model="open" size="md" :close-on-outside-click="false">
            <iframe
                width="100%"
                height="750px"
                src="https://booking.conda.online/portal-embed#/KYC"
                frameborder="0"
                allowfullscreen="false">
            </iframe>
        </Modal>
    </div>
</template>
